import {initPurchaseConfirmation} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/reward/sliceMaker'

const rewardSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmation.fulfilled, (state, {payload}) => {
            state.products = payload.data.purchaseDecisionTargets.map((product) => {
                return {
                    itemId: product.productOrderNo,
                    imageUrl: product.productImageUrl,
                    name: product.productName ?? '',
                }
            })
        })
    },
})

export default rewardSlice.reducer
